export default "__VITE_ASSET__7c74bff2__"